<template>
  <div v-if="custDetail" class="col-md requestlistdetail__content">
    <div class="requestlistdetail__content--title mb-3">SHIPMENT TYPE</div>
    <div v-for="(item, i) in data" :key="i">
      <div v-if="item.show" :class="styletable.row">
        <div :class="styletable.col1">{{ item.label }}</div>
        <div :class="styletable.col2">:</div>
        <div v-if="!canEdit" :class="styletable.col3">
          {{ item.label === 'Estimate Total Weight' ||  item.label === 'Volumetric' || item.label === 'Weight per Container' ? parseFloat(item.value).toLocaleString() : item.value }}
          {{ item.label === 'Estimate Total Weight' || item.label === 'Weight per Container' ? 'Kg' : item.label === 'Volumetric'
          ? 'CBM' : item.label === 'Size' ? 'Cm' : '' }}</div>
  
        <div :class="styletable.col3" 
          v-else-if="canEdit && (
          item.label === 'Freight Mode' ||
          item.label === 'Shipment Type' ||
          item.label === 'Container Type' ||
          item.label === 'Container Option' ||
          item.label === 'Cargo Packaging Type')"
        >
          <div class="options__multiselect">
            <multiselect
              v-model="item.fieldDropdown"
              :options="getOptions(item)"
              placeholder="Select"
              :name="item.label"
              @input="chooseDropdown(item)"
              v-validate="{required : item.show}"
              label="name" selectedLabel=""
              :select-label="''" :deselect-label="''"
              :disabled="item.label === 'Freight Mode'"
              >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
          </div>
          <p v-if="errors.has(item.label)" class="global__texterror text-left py-1">
            {{ errors.first(item.label) }}
          </p>
        </div>

        <div
          v-else-if="canEdit && item.label === 'Estimate Total Weight'"
          :class="styletable.col3" 
        >
          <b-input-group append="Kg">
            <b-form-input
              type="number"
              class="input_field"
              :formatter="formatMaxLength10"
              :name="item.label"
              v-model="item.value"
              v-validate="'required'"
              :disabled="item.disabled"
            />
          </b-input-group>
          <p v-if="errors.has(item.label)" class="global__texterror text-left py-1">
            {{ errors.first(item.label) }}
          </p>
        </div>

        <div
          v-else-if="canEdit && item.label === 'Volumetric'"
          :class="styletable.col3" 
        >
          <b-input-group append="CBM">
            <b-form-input
              type="number"
              class="input_field"
              :formatter="formatMaxLength10"
              :name="item.label"
              v-model="item.value"
              v-validate="'required'"
              :disabled="item.disabled"
            />
          </b-input-group>
          <p v-if="errors.has(item.label)" class="global__texterror text-left py-1">
            {{ errors.first(item.label) }}
          </p>
        </div>

        <div v-else-if="canEdit && item.label === 'Size Per Package'"
          :class="styletable.col3" >
          <b-input-group class="col-md p-0" append="Cm">
            <b-form-input class="input_field" name="length" placeholder="L" type="number" :formatter="formatMaxLenght6"
              v-model="formShipment.dimension.length" @input="calculate()" v-validate="'required'"/>
            <b-form-input class="input_field" name="width" placeholder="W" type="number" :formatter="formatMaxLenght6"
              v-model="formShipment.dimension.width" @input="calculate()" v-validate="'required'"/>
            <b-form-input class="input_field" name="height" placeholder="H" type="number" :formatter="formatMaxLenght6"
              v-model="formShipment.dimension.height" @input="calculate()" v-validate="'required'"/>
          </b-input-group>
          <p v-if="errors.has('length') || errors.has('width') || errors.has('height')"
              class="global__texterror text-left py-1">
            The Dimension field is required
          </p>
        </div>
  
        <div
          v-else
          :class="styletable.col3" 
        >
          <b-input-group>
            <b-form-input
              type="number"
              class="input_field"
              v-validate="{required : item.show}"
              :formatter="formatMaxLength10"
              @input="calculate(i)"
              name="name"
              v-model="item.value"
              :disabled="item.disabled"
            />
          </b-input-group>
        </div>
      </div>
    </div>
    <button class="button__bluecorporite mt-3" v-if="isLoadingEditIq">
      <b-spinner small variant="secondary"></b-spinner>
    </button>
    <button class="button__bluecorporite mt-3"
    v-else-if="!canEdit && !isLoadingEditIq" @click="chooseEdit(true)">Edit</button>
    <div class="row m-0 mt-3" v-else-if="canEdit">
      <button class="button__redcorporite mr-3" @click="updateData">Save</button>
      <button class="button__whitesquere" @click="chooseEdit(false)">Cancel</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import mixin from '@/mixin/getters/shipment-details'

export default {
  name: 'ShipmentType',
  props: {
    custDetail: Object,
    canEdit: Boolean
  },
  mixins: [mixin],
  data () {
    return {
      form: {},
      styletable: {
        row: 'row m-0 mb-1',
        col1: 'col-md-4 pl-0',
        col2: 'col-md-0',
        col3: 'col-md-5 pl-1 textcolor textbold'
      },
      formShipment: {
        dimension: {
          length: 0,
          width: 0,
          height: 0
        }
      },
      data: [
        {
          label: 'Freight Mode',
          payloadVar: 'freightMode',
          show: true,
          value: '',
          fieldDropdown: ''
        },
        {
          label: 'Shipment Type',
          payloadVar: 'shipmentType',
          show: true,
          value: '',
          fieldDropdown: ''
        },
        {
          label: 'Container Type',
          payloadVar: 'containerType',
          show: false,
          value: '',
          fieldDropdown: ''
        },
        {
          label: 'Temperature',
          payloadVar: 'temperature',
          show: false,
          value: ''
        },
        {
          label: 'Container Quantity',
          payloadVar: 'totalQuantity',
          show: true,
          value: ''
        },
        {
          label: 'Cargo Packaging Type',
          payloadVar: 'cargoPackagingType',
          show: true,
          value: '',
          fieldDropdown: ''
        },
        {
          label: 'Weight per Container',
          payloadVar: 'weightPerContainer',
          show: true,
          value: ''
        },
        {
          label: 'Container Option',
          payloadVar: 'containerOption',
          show: false,
          value: '',
          fieldDropdown: ''
        },
        {
          label: 'Estimate Total Weight',
          payloadVar: 'estimatedTotalWeight',
          show: false,
          value: '',
          disabled: true
        },
        {
          label: 'Volumetric',
          payloadVar: 'volume',
          show: false,
          value: '',
          disabled: true
        },
        {
          label: 'Size Per Package',
          payloadVar: 'size',
          show: false,
          value: ''
        }
      ],
      packingList: [],
      freightMode: [
        { name: 'Air', value: 'AIR' },
        { name: 'Ocean', value: 'OCEAN' }
      ],
      shipmentType: [
        { name: 'LCL', value: 'SEALCL' },
        { name: 'FCL 20FT', value: 'SEAFCL20FT' },
        { name: 'FCL 40FT', value: 'SEAFCL40FT' },
        { name: 'FCL 45FT', value: 'SEAFCL45FT' },
        { name: 'FCL 20FR', value: 'SEAFCL20FR' },
        { name: 'FCL 40FR', value: 'SEAFCL40FR' },
        { name: 'FCL 20RF', value: 'SEAFCL20RF' },
        { name: 'FCL 40HREF', value: 'SEAFCL40HREF' },
        { name: 'FCL 40FT HC', value: 'SEAFCL40FTHC' },
        { name: 'Breakbulk', value: 'SEABREAKBULK' }
      ],
      containerType: [
        { name: 'Dry', value: 'Dry' },
        { name: 'Ventilate', value: 'Ventilate' },
        { name: 'Reefer', value: 'Reefer' },
        { name: 'Open Top', value: 'Open Top' },
        { name: 'ISO Tank', value: 'ISO Tank' },
        { name: 'NOR', value: 'NOR' }
      ],
      containerOption: [
        { name: "Shipper's Own Container (SOC)", value: 'SOC' },
        { name: "Carrier's Owned Container (COC)", value: 'COC' }
      ],
      packagingType: [
        { value: 'Boxes', name: 'Boxes' },
        { value: 'Cartons', name: 'Cartons' },
        { value: 'Cases', name: 'Cases' },
        { value: 'Drums', name: 'Drums' },
        { value: 'Packages', name: 'Packages' },
        { value: 'Palletes', name: 'Palletes' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      editIq: 'instantQuote/editIq',
      errorEditIq: 'instantQuote/errorEditIq',
      isLoadingEditIq: 'instantQuote/isLoadingEditIq'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.form = Object.assign({}, this.custDetail.details.shipmentType)
      this.packingList = JSON.parse(this.custDetail.details.shipmentType.packingList)
      // Freight Mode
      const optionFreightMode = this.freightMode.filter(item => item.value.includes(this.custDetail.details.shipmentType.freightMode))[0]
      this.data[0].value = optionFreightMode ? optionFreightMode.name : this.custDetail.details.shipmentType.freightMode
      this.data[0].fieldDropdown = optionFreightMode || {}

      // Shipment Type
      const optionShipmentType = this.shipmentType.filter(item => item.value.includes(this.packingList[0].shipmentType))[0]
      this.data[1].value = optionShipmentType ? optionShipmentType.name : this.packingList[0].shipmentType
      this.data[1].fieldDropdown = optionShipmentType || {}

      // Container Type
      const optionContainerType = this.containerType.filter(item => item.value.includes(this.packingList[0].containerType))[0]
      this.data[2].show = this.data[1].value.includes('FCL')
      this.data[2].value = optionContainerType ? optionContainerType.name : this.packingList[0].containerType
      this.data[2].fieldDropdown = optionContainerType || {}

      // Temperature
      this.data[3].show = this.data[2].fieldDropdown.value === 'Reefer'
      this.data[3].value = this.packingList[0].temperature

      // Container Quantity
      this.data[4].value = this.custDetail.details.shipmentType.totalQuantity

      // Cargo Packaging Type
      const optionPackagingType = this.packagingType.filter(item => item.value.includes(this.packingList[0].satuan))[0]
      this.data[5].value = optionPackagingType ? optionPackagingType.name : this.packingList[0].satuan
      this.data[5].fieldDropdown = optionPackagingType || {}

      // Weight per Container
      this.data[6].value = `${this.packingList[0].weight}`

      // Container Option
      const optionContainerOption = this.containerOption.filter(item => item.value.includes(this.packingList[0].containerOption))[0]
      this.data[7].show = this.data[1].value.includes('FCL')
      this.data[7].value = optionContainerOption ? optionContainerOption.name : this.packingList[0].containerOption
      this.data[7].fieldDropdown = optionContainerOption || {}

      // estimasi
      this.data[8].value = this.custDetail.details.shipmentType.estimatedTotalWeight

      // volume
      this.data[9].value = this.custDetail.details.shipmentType.volume

      // size
      this.data[10].value = `${this.packingList[0].length || 0} x ${this.packingList[0].width || 0} x ${this.packingList[0].height || 0} Cm`

      // condition
      this.data[8].show = !this.custDetail.details.shipmentType.shipmentType.includes('FCL')
      this.data[9].show = !this.custDetail.details.shipmentType.shipmentType.includes('FCL')
      this.data[10].show = !this.custDetail.details.shipmentType.shipmentType.includes('FCL')

      this.formShipment.dimension.length = this.packingList[0].length
      this.formShipment.dimension.width = this.packingList[0].width
      this.formShipment.dimension.height = this.packingList[0].height
    },
    formatMaxLength10 (e) {
      return String(e).substring(0, 10)
    },
    chooseEdit (data) {
      this.$emit('chooseEdit', data)
      this.init()
    },
    chooseDropdown (item) {
      if (item.label === 'Shipment Type') {
        this.data[2].show = item.fieldDropdown.value.includes('FCL')
        this.data[7].show = item.fieldDropdown.value.includes('FCL')
        this.data[8].show = !item.fieldDropdown.value.includes('FCL')
        this.data[9].show = !item.fieldDropdown.value.includes('FCL')
        this.data[10].show = !item.fieldDropdown.value.includes('FCL')
      }
      if (item.label === 'Container Type') {
        this.data[3].show = item.fieldDropdown.value === 'Reefer'
        this.data[3].value = ''
      }
    },
    updateData () {
      // assigning the dropdown
      this.data.forEach((item) => {
        if (
          item.label === 'Freight Mode' ||
          item.label === 'Shipment Type' ||
          item.label === 'Container Type' ||
          item.label === 'Container Option' ||
          item.label === 'Cargo Packaging Type'
        ) {
          const value = item.fieldDropdown
          let itemName = ''
          let itemCode = ''
          if (item.label === 'Freight Mode') {
            itemName = { freightMode: value.name }
            itemCode = { freightMode: value.value }
          } else if (item.label === 'Shipment Type') {
            itemName = { shipmentType: value.name }
            itemCode = { shipmentType: value.value }
          } else if (item.label === 'Container Type') {
            itemName = { containerType: value.name }
            itemCode = { containerType: value.value }
          } else if (item.label === 'Container Option') {
            itemName = { containerOption: value.name }
            itemCode = { containerOption: value.value }
          } else if (item.label === 'Cargo Packaging Type') {
            itemName = { cargoPackagingType: value.name }
            itemCode = { cargoPackagingType: value.value }
          }
          this.form = Object.assign(this.form, itemName, itemCode)
        } else {
          // eslint-disable-next-line no-new-object
          const data = new Object()
          if (item.label === 'Temperature' || item.label === 'Weight per Container') {
            data[item.payloadVar] = parseInt(item.value, 10)
          } else {
            data[item.payloadVar] = item.value
          }
          this.form = Object.assign(this.form, data)
        }
      })

      // Adding the packing list
      const packingList = [{
        shipmentType: this.form.shipmentType,
        containerType: this.form.containerType || null,
        temperature: this.form.temperature,
        qty: this.form.totalQuantity,
        containerOption: this.form.containerOption || null,
        satuan: this.form.cargoPackagingType || null,
        weight: this.form.weightPerContainer,
        length: this.formShipment.dimension.length,
        width: this.formShipment.dimension.width,
        height: this.formShipment.dimension.height
      }]

      this.form = Object.assign(this.form, { packingList: JSON.stringify(packingList) })
      const {size: _, ...newObj} = this.form
      const payload = {
        editable: 'shipmentType',
        data: newObj
      }
      // Validate and send the payload
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('instantQuote/PUT_EDIT_IQ', {
            id: this.$route.params.id_iq,
            payload
          }).then(() => {
            if (!this.errorEditIq) {
              this.$store.dispatch('instantQuote/FETCH_IQ_BY_ID', this.$route.params.id_iq)
              this.$emit('chooseEdit', false)
            }
          })
        }
      })
    },
    calculate (index) {
      // weight
      if (index === 4 || index === 6) {
        if (this.data[4].value && this.data[6].value) {
          this.data[8].value = this.custDetail.details.shipmentType.shipmentType.includes('SEABREAKBULK')
            ? parseFloat(this.data[4].value) * parseFloat(this.data[6].value) / 1000 : parseFloat(this.data[4].value) * parseFloat(this.data[6].value)
        }
      }
      // volume
      const cbm = 1000000
      const dimension = this.formShipment.dimension
      if (dimension.length && dimension.width && dimension.height && this.data[4].value) {
        const total = parseFloat(dimension.length) * parseFloat(dimension.width) * parseFloat(dimension.height)
        this.data[9].value = this.custDetail.details.shipmentType.shipmentType.includes('SEABREAKBULK')
          ? total * parseFloat(this.data[4].value)
          : (total / cbm) * parseFloat(this.data[4].value)
      }
    },
    getOptions (item) {
      let options = []
      if (item.label === 'Freight Mode') {
        options = this.freightMode
      } else if (item.label === 'Shipment Type') {
        options = this.shipmentType
      } else if (item.label === 'Container Type') {
        options = this.containerType
      } else if (item.label === 'Container Option') {
        options = this.containerOption
      } else if (item.label === 'Cargo Packaging Type') {
        options = this.packagingType
      }
      return options
    },
    formatMaxLenght6 (e) {
      return String(e).substring(0, 6)
    }
  },
  created () {
    this.$eventHub.$on('reset-data', this.resetData)
  },
  beforeDestroy () {
    this.$eventHub.$off('reset-data')
  },
  watch: {
    custDetail (data) {
      if (data) {
        this.init()
      }
    }
  }
}
</script>
<style scoped>
.options__multiselect {
  .multiselect__placeholder {
    font-size: 14px;
  }
  .multiselect__tags {
    padding-top: 0;
    min-width: 70px;
  }
  .multiselect__single {
    font-size: 14px;
    color: #1D3354;
    padding-top: 3px;
  }
}

.input_field {
  font-size: 14px;
  color: #686868;
  padding: 3px 10px;
  height: 28px;
  border-radius: 2px;
  border: 1px solid #a9a9a9;
}

.form-control {
  min-height: 0px !important;
}

.input-group {
  .input-group-append {
    .input-group-text {
      font-size: 12px;
      height: 28px;
      border-radius: 2px;
      border: 1px solid #a9a9a9;
      background-color: #a9a9a9;
      color: #686868;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/requestList/detail-instant-quote/tabs-detail/ShipmentType.vue